import { styled } from '@mui/material';

export const AppRoot = styled('div')({
  height: '100%',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
});

export const AppContent = styled('div')({
  flexGrow: 1,
  overflow: 'auto',
});

export const LoaderWrapper = styled('div')({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
